import ApiService from "@/core/services/api.service";
import querystring from 'querystring';
import moment from "moment";
import {
    LARAVEL_DATE_TIME_FORMAT,
    LARAVEL_RAW_DATE_TIME_FORMAT,
} from "@/core/config/constant";

const BASE = 'SAMPLE/CREATE/MEETING/DETAIL';

// GETTERS
export const MEETING = `${BASE}/MEETING`;
export const LOADING = `${BASE}/LOADING`;
export const ERROR = `${BASE}/ERROR`;
export const SELECTED_USER = `${BASE}/SELECTED_USER`;
export const SAMPLE_USERS = `${BASE}/USERS`;

// MUTATIONS
export const SET_MEETING = `${BASE}/M/MEETING`;
export const SET_LOADING = `${BASE}/M/LOADING`;
export const SET_ERROR = `${BASE}/M/ERROR`;
export const SET_SELECTED_USER = `${BASE}/M/SELECTED_USER`;
export const SET_SAMPLE_USERS = `${BASE}/M/USERS`;

// ACTIONS
export const GET_MEETING_DETAIL = `${BASE}/A/GET_MEETING_DETAIL`;
export const CREATE_SAMPLE = `${BASE}/A/CREATE_SAMPLE`;
export const GET_SAMPLE_USERS = `${BASE}/A/CREATE_SAMPLE_USER`;


const state = {
    meeting: null,
    loading: false,
    error: null,
    selectedUser: null,
    users: []
};

const getters = {
    [MEETING]: (state) => {
        return state.meeting;
    },
    [LOADING]: (state) => {
        return state.loading;
    },
    [ERROR]: (state) => {
        return state.error;
    },
    [SELECTED_USER]: (state) => {
        return state.selectedUser;
    },
    [SAMPLE_USERS]: (state) => {
        return state.users;
    },

};

const mutations = {
    [SET_LOADING]: (state, payload) => {
        state.loading = payload;
    },
    [SET_ERROR]: (state, payload) => {
        state.error = payload;
    },
    [SET_MEETING]: (state, payload) => {
        console.log(payload);
        state.meeting = payload;
    },
    [SET_SELECTED_USER]: (state, payload) => {
        state.selectedUser = payload;
    },
    [SET_SAMPLE_USERS]: (state, payload) => {
        state.users = payload;
    }


};

const actions = {
    [GET_MEETING_DETAIL]: (context, payload) => {
        context.commit(SET_LOADING, true);
        ApiService.get(`api/meetings/${payload.params.id}`).then((response ) => {
            context.commit(SET_LOADING, false);
            context.commit(SET_MEETING, response.data);
            console.log(response.data);
        }).catch((error) => {
            context.commit(SET_LOADING, false);
            context.commit(SET_ERROR, error);
        });
    },
    [GET_SAMPLE_USERS]: (context) => {
        context.commit(SET_LOADING, true);
        ApiService.get(`api/sample-users`).then((response ) => {
            context.commit(SET_LOADING, false);
            context.commit(SET_SAMPLE_USERS, response.data);
        }).catch((error) => {
            context.commit(SET_LOADING, false);
            context.commit(SET_ERROR, error);
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};